export default "__VITE_ASSET__DnAIT3Sf__"